import React from "react";

function UploadedImage({
  src: imgSrc,
  height = "100%",
  width = "100%",
  children,
}) {
  const handleImageError = (e) => {
    if (e.target.src.includes("data:image/svg;base64,")) {
      e.target.src = `data:image/svg+xml;base64,${imgSrc}`;
      return;
    } else if (e.target.src.includes("data:image/svg+xml;base64,")) {
      return;
    } else {
      e.target.src = `data:image/svg;base64,${imgSrc}`;
    }
  };
  return (
    <>
      <img
        src={imgSrc}
        alt="test"
        style={{
          height,
          width,
          objectFit: "contain",
        }}
        onError={handleImageError}
      />
      {children}
    </>
  );
}

export default UploadedImage;
